import React from 'react';
import AnsprechpartnerForm from './AnsprechpartnerForm';

const FormTabs = ({
                      register,
                      errors,
                      touchedFields,
                      setValue,
                      getValues,
                      ansprechpartnerList,
                      setAnsprechpartnerList,
                      sameAsEntscheider,
                      setSameAsEntscheider,
                      watch
                  }) => {
    return (
        <div>
            <AnsprechpartnerForm
                register={register}
                errors={errors}
                touchedFields={touchedFields}
                setValue={setValue}
                getValues={getValues}
                ansprechpartnerList={ansprechpartnerList}
                setAnsprechpartnerList={setAnsprechpartnerList}
                sameAsEntscheider={sameAsEntscheider}
                setSameAsEntscheider={setSameAsEntscheider}
                watch={watch}
            />
        </div>
    );
};

export default FormTabs;
